<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>服务费标签</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select
            v-model="listQuery.cityId"
            clearable
            placeholder="请选择城市"
            @change="cityChange"
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.cityAddress"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务站">
          <el-select
            v-model="listQuery.stationId"
            clearable
            placeholder="请选择服务站"
          >
            <el-option
              v-for="(item, index) in stationList"
              :key="index"
              :label="item.stationName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务者">
          <el-input
            v-model="listQuery.workerName"
            placeholder="请输入服务者姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="listQuery.workerTel"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="标签类型">
          <el-select
            v-model="listQuery.lableType"
            clearable
            placeholder="请选择标签类型"
          >
            <el-option label="新农保" value="新农保"></el-option>
            <el-option label="鲸选" value="鲸选"></el-option>
            <!-- <el-option label="其他商业险" value="其他商业险"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="有效状态">
          <el-select
            v-model="listQuery.state"
            clearable
            placeholder="请选择状态"
            v-if="listQuery.lableType == '鲸选'"
          >
            <el-option label="有效" value="有效"></el-option>
            <el-option label="失效" value="失效"></el-option>
          </el-select>
          <el-select
            v-model="listQuery.state"
            clearable
            placeholder="请选择状态"
            v-if="listQuery.lableType == '新农保'"
          >
            <el-option label="未上传" value="1"></el-option>
            <el-option label="生效中" value="2"></el-option>
            <el-option label="审核中" value="3"></el-option>
            <el-option label="已过期" value="4"></el-option>
            <el-option label="审核未通过" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="listQuery.isAudit"
            clearable
            placeholder="请选择审核状态"
          >
            <el-option label="已审核" :value="1"></el-option>
            <el-option label="未审核" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            plan
            @click="querySearch"
            >查询</el-button
          >
          <el-button icon="el-icon-plus" type="primary" plan @click="addLabel"
            >新增标签</el-button
          >
          <a
            href="https://servant.lifejingzhi.com/file/salary/newSocialInsureTemplate.xlsx"
            download="新农保模板.xlsx"
          >
            <el-button type="danger" icon="el-icon-download"
              >新农保模版下载</el-button
            >
          </a>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            @click="uploadBtn"
            v-per="'newInsureImport'"
            >新农保明细导入</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column
          prop="id"
          label="ID"
          width="50px"
          fixed="left"
        ></el-table-column>

        <el-table-column
          prop="workerNo"
          label="编号"
          width="100px"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="workerName" label="姓名"></el-table-column>
        <el-table-column prop="city" label="城市"></el-table-column>
        <el-table-column prop="station" label="服务站"></el-table-column>
        <!-- <el-table-column prop="workerTel" label="手机号"></el-table-column> -->
        <el-table-column
          prop="effectiveStart"
          label="有效期始"
          :formatter="dateFormatB"
          width="140px"
        ></el-table-column>
        <el-table-column
          prop="effectiveEnd"
          label="有效期止"
          :formatter="dateFormatB"
          width="140px"
        ></el-table-column>

        <el-table-column prop="lableType" label="标签"></el-table-column>
        <el-table-column prop="files" label="附件" width="200px" >
             <template slot-scope="scope">
            <span v-if="scope.row.files == ''">无</span>
            <el-image
              v-else
              slot="reference"
              :preview-src-list="scope.row.files.split(',')"
              v-for="item in scope.row.files.split(',')"
              :key="item.index"
              :src="item"
              style="width: 50px; height: 50px"
            ></el-image></template>
        </el-table-column>
        <el-table-column prop="state" label="状态"></el-table-column>
        <!-- <el-table-column prop="isAudit" label="是否审核">
              
        </el-table-column> -->
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column
          prop="auditDate"
          label="审核时间"
          :formatter="dateFormatA"
          width="140px"
        ></el-table-column>
        <el-table-column prop="auditUserName" label="审核人"></el-table-column>
        <el-table-column prop="auditRemark" label="审核备注"></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="dateFormatA"
          width="140px"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          :formatter="dateFormatA"
          width="140px"
        ></el-table-column>

        <el-table-column
          prop
          label="操作"
          fixed="right"
          width="180px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="auditLabel(scope.row)"
              :disabled="!scope.row.auditUserId == ''"
              size="mini"
              >审核</el-button
            >
            <el-button
              type="text"
              @click="editLabel(scope.row)"
              :disabled="scope.row.state == '失效'"
              size="mini"
              v-per="'editLabel'"
              >修改</el-button
            >
            <el-button
              type="text"
              @click="cancelLabel(scope.row)"
              :disabled="scope.row.state == '失效'"
              size="mini"
              v-per="'cancelLabel'"
              >取消标签</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!-- 审核备注  -->
    <el-dialog
      title="审核备注"
      :visible.sync="auditVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="auditForm"
        :inline="true"
        :model="auditForm"
        label-width="80px"
      >
        <el-form-item label="状态" prop="state">
          <el-select
            v-model="auditForm.state"
            placeholder="请选择状态"
            @change="changeState"
          >
            <el-option label="同意" value="2"></el-option>
            <el-option label="拒绝" value="5"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="refuseVisible" style="margin:0px 0px 20px 40px;">
          <div class="flex gap-2">
            <div class="sugResponse">推荐回复:</div>
            <el-tag
              type="primary"
              v-for="(item, index) in refuseContent"
              :key="index"
              @click="clickReason(item)"
              style="margin: right 10px ;"
              >{{ item }}</el-tag
            >
          </div>
        </div>

        <el-form-item label="备注" prop="mark">
          <el-input
            type="textarea"
            style="width:450px"
            :rows="3"
            placeholder="请输入内容"
            v-model="auditForm.auditRemark"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button type="primary" @click="confAudit()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 新增标签 -->
    <el-dialog
      title="新增标签"
      :visible.sync="addLabelVisible"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addLabelForm"
        :rules="addRules"
        label-width="100px"
        :model="addLabelForm"
        size="medium"
        inline
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="城市" prop="cityId">
              <el-select
                v-model="addLabelForm.cityId"
                clearable
                placeholder="请选择城市"
                @change="cityChange2"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.cityAddress"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务站" prop="stationId">
              <el-select
                v-model="addLabelForm.stationId"
                clearable
                placeholder="请选择服务站"
                @change="stationChange2"
              >
                <el-option
                  v-for="(item, index) in stationList2"
                  :key="index"
                  :label="item.stationName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务者" prop="workerNo">
              <el-select
                v-model="addLabelForm.workerNo"
                clearable
                placeholder="请选择服务者"
                filterable
              >
                <el-option
                  v-for="(item, index) in workerList"
                  :key="index"
                  :label="item.workerName"
                  :value="item.workerNo"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签类型" prop="lableType">
              <el-select
                v-model="addLabelForm.lableType"
                clearable
                placeholder="请选择标签类型"
              >
                <el-option label="鲸选" value="鲸选"></el-option>
                <el-option label="新农保" value="新农保"></el-option>
                <!-- <el-option label="其他商业险" value="其他商业险"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期开始" prop="effectiveStart">
              <div class="block">
                <el-date-picker
                  v-model="addLabelForm.effectiveStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期结束" prop="effectiveEnd">
              <div class="block">
                <el-date-picker
                  v-model="addLabelForm.effectiveEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="mark">
            <el-input
              type="textarea"
              style="width:460px"
              :rows="3"
              placeholder="请输入备注"
              v-model="addLabelForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:" prop="mark"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile"
          :on-change="handleOnChange"
          :file-list="addLabelImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <!-- </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addLabelVisible = false">取 消</el-button>
        <el-button type="primary" @click="confAddLabel('addLabelForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改标签 -->
    <el-dialog
      title="修改标签"
      :visible.sync="editLabelVisible"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="editLabelForm"
        :rules="editRules"
        label-width="100px"
        :model="editLabelForm"
        size="medium"
        inline
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务者" prop="workerNo">
              <el-select
                v-model="editLabelForm.workerNo"
                clearable
                placeholder="请选择服务者"
                disabled
              >
                <el-option
                  v-for="(item, index) in workerList"
                  :key="index"
                  :label="item.workerName"
                  :value="item.workerNo"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签类型" prop="lableType">
              <el-select
                v-model="editLabelForm.lableType"
                clearable
                placeholder="请选择标签类型"
              >
                <el-option label="鲸选" value="鲸选"></el-option>
                <el-option label="新农保" value="新农保"></el-option>
                <el-option label="其他商业险" value="其他商业险"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="有效期开始" prop="effectiveStart">
              <div class="block">
                <el-date-picker
                  v-model="editLabelForm.effectiveStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期结束" prop="effectiveEnd">
              <div class="block">
                <el-date-picker
                  v-model="editLabelForm.effectiveEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="mark">
            <el-input
              type="textarea"
              style="width:460px"
              :rows="3"
              placeholder="请输入备注"
              v-model="editLabelForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:" prop="mark"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile2"
          :on-change="handleOnChange2"
          :file-list="editLabelImgList"
          :limit="5"
          :on-exceed="uploadOverrun2"
          :auto-upload="false"
          :on-remove="handleRemove2"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <!-- </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editLabelVisible = false">取 消</el-button>
        <el-button type="primary" @click="confEditLabel('editLabelForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="inputVisible"
      width="500px"
      :close-on-click-modal="false"
      center
    >
      <input type="file" @change="getFile($event)" ref="file" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="inputVisible = false">取 消</el-button>
        <el-button type="primary" @click="importConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
  components: { Pagination },
  data() {
    return {
      inputVisible: false,
      file: "",
      labelInfo: {},
      addLabelImgList: [],
      editLabelImgList: [],
      addFile: Service.addFile + globalData.userInfo.userAccount,
      addFile2: Service.addFile + globalData.userInfo.userAccount,
      auditVisible: false,
      auditForm: {
        state: "2",
        auditRemark: ""
      },
      addLabelVisible: false,
      editLabelVisible: false,
      addLabelForm: {
        cityId: "",
        stationId: "",
        workerNo: "",
        lableType: "",
        effectiveStart: "",
        effectiveEnd: "",
        remark: ""
      },
      editLabelForm: {
        workerNo: "",
        workerName: "",
        lableType: "",
        effectiveStart: "",
        effectiveEnd: "",
        remark: ""
      },
      workerList: [],
      addRules: {
        cityId: [{ required: true, message: "请选择城市", trigger: "change" }],
        // stationId: [
        //   { required: true, message: "请选择服务站", trigger: "change" }
        // ],
        workerNo: [
          { required: true, message: "请选择服务者", trigger: "change" }
        ],
        lableType: [
          { required: true, message: "请选择标签类型", trigger: "change" }
        ],
        effectiveStart: [
          { required: true, message: "请选择有效期开始日期", trigger: "change" }
        ]
      },
      editRules: {
        lableType: [
          { required: true, message: "请选择标签类型", trigger: "change" }
        ],
        effectiveStart: [
          { required: true, message: "请选择有效期开始日期", trigger: "change" }
        ]
      },
      stationList2: [],
      labelId: "",
      cityList: [],
      stationList: [],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId: "",
        stationId: "",
        workerName: "",
        workerTel: "",
        lableType: "新农保",
        state: "",
        isAduit: ""
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 12);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      refuseVisible: false,
      refuseContent: [], //拒绝理由,
      selectResponse: [] //选中的原因
    };
  },
  created() {
    this.cityList = JSON.parse(window.localStorage.getItem("allCityList"));
    if (!window.localStorage.getItem("allCityList")) {
      Service.$axiosGetAllCityStation({
        // userId:  JSON.parse(window.localStorage.getItem("userInfo")).id
      }).then(res => {
        if (res.data.errno == "0") {
          this.cityList == res.data.data;
          window.localStorage.setItem(
            "allCityList",
            JSON.stringify(this.cityList)
          );
        } else {
          this.$message.warning(res.data.errmsg);
        }
      });
    }
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        cityId: this.listQuery.cityId,
        stationId: this.listQuery.stationId,
        workerName: this.listQuery.workerName,
        workerTel: this.listQuery.workerTel,
        lableType: this.listQuery.lableType,
        state: this.listQuery.state,
        isAudit: this.listQuery.isAudit
      };
      Service.$axiosGetSalaryLabelList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityChange(value) {
      this.listQuery.stationId = "";
      let currentStation = this.cityList.filter(item => {
        return item.id == value;
      });
      this.stationList = currentStation[0].stationList;
    },
    cityChange2(value) {
      this.addLabelForm.stationId = "";
      let currentStation = this.cityList.filter(item => {
        return item.id == value;
      });
      this.stationList2 = currentStation[0].stationList;
      this.addLabelForm.workerNo = "";
      Service.$axiosGetWorkerList({
        cityId: this.addLabelForm.cityId
      })
        .then(res => {
          this.workerList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    stationChange2(value) {
      this.addLabelForm.workerNo = "";
      if (value != null) {
        Service.$axiosGetWorkerList({
          cityId: this.addLabelForm.cityId,
          stationId: this.addLabelForm.stationId
        })
          .then(res => {
            this.workerList = res.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    dateChange(e) {
      if (e != null) {
        let start =
          new Date(e[0]).getFullYear() * 12 + new Date(e[0]).getMonth();
        let end = new Date(e[1]).getFullYear() * 12 + new Date(e[1]).getMonth();
        let isOvertime = end - start - 12 > 0;
        // if (isOvertime) {
        //   this.$message.warning("选中时间范围不能超过一年");
        //   this.listQuery.timePart = null;
        // }
      }
    },
    cancelLabel(row) {
      this.$confirm("确定取消标签吗？")
        .then(_ => {
          Service.$axiosCancelLabel({
            updateUserId: globalData.userInfo.id,
            id: row.id
          })
            .then(res => {
              this.$message.success("取消成功！");
              this.querySearch();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(_ => {});
      console.log(row);
    },
    //选中不同的审批状态时触发
    changeState(e) {
      if (e == 5) {
        this.refuseVisible = true;
        Service.$axioGetRefuseContent().then(res => {
          if (res.data.errno == 0) {
            this.refuseContent = res.data.data;
            this.auditForm.auditRemark;
          }
        });
      } else {
        this.refuseVisible = false;
        this.auditForm.auditRemark = "";
        this.selectResponse = [];
      }
    },
    clickReason(item) {
      this.selectResponse.push(item);
      if (this.auditForm.auditRemark !== "") {
        this.auditForm.auditRemark += "," + item 
      } else {
        this.auditForm.auditRemark = this.selectResponse.join(",");
      }
    },

    auditLabel(row) {
      this.labelId = row.id;
      this.auditVisible = true;
      this.auditForm = {
        state: "2",
        auditRemark: ""
      };
    },
    confAudit() {
      Service.$axiosLabelPpprove({
        updateUserId: globalData.userInfo.id,
        auditUserName: globalData.userInfo.userName,
        id: this.labelId,
        auditRemark: this.auditForm.auditRemark,
        state: this.auditForm.state
      })
        .then(res => {
          console.log("111", res);
          this.$message.success("审核完成！");
          this.auditVisible = false;
          this.refuseVisible = false;
          this.selectResponse = [];
          this.querySearch();
        })
        .catch(err => {
          console.log(err);
        });
    },

    confAddLabel(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let labelImg = this.addLabelImgList.map(item => {
            return item.url;
          });
          let workerItem = this.workerList.filter(item => {
            return item.workerNo == this.addLabelForm.workerNo;
          });
          let params = {
            createUserId: globalData.userInfo.id,
            effectiveEnd: this.addLabelForm.effectiveEnd,
            effectiveStart: this.addLabelForm.effectiveStart,
            files: labelImg.join(","),
            lableType: this.addLabelForm.lableType,
            remark: this.addLabelForm.remark,
            workerNo: this.addLabelForm.workerNo,
            workerName: workerItem[0].workerName
          };

          Service.$axiosAddSalaryLabel(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addLabelVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confEditLabel(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let labelImg = this.editLabelImgList.map(item => {
            return item.url;
          });

          let params = {
            updateUserId: globalData.userInfo.id,
            effectiveEnd: this.editLabelForm.effectiveEnd,
            effectiveStart: this.editLabelForm.effectiveStart,
            files: labelImg.join(","),
            lableType: this.editLabelForm.lableType,
            remark: this.editLabelForm.remark,
            workerNo: this.labelInfo.workerNo,
            workerName: this.labelInfo.workerName,
            id: this.labelInfo.id
          };

          Service.$axiosUpdateSalaryLabel(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("修改成功");
              this.editLabelVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addLabel() {
      this.addLabelVisible = true;
      this.addLabelForm = {
        cityId: "",
        stationId: "",
        workerNo: "",
        lableType: "",
        effectiveStart: "",
        effectiveEnd: "",
        remark: ""
      };
      this.addLabelImgList = [];
      this.stationList2 = [];
      this.workerList = [];
    },
    uploadOverrun: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    uploadOverrun2: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    handleRemove: function(file, fileList) {
      console.log(file, fileList);
      this.addLabelImgList = fileList;
    },
    handleRemove2: function(file, fileList) {
      console.log(file, fileList);
      this.editLabelImgList = fileList;
    },
    handleOnChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);

        let filesize = Number(file.size / 1024 / 1024);
        if (filesize > 3) {
          this.$message.error("上传图片不能超过3M,请重新上传");
          const currIdx = this.addLabelImgList.indexOf(file);
          this.addLabelImgList.splice(currIdx, 0);
          return;
        }

        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.addLabelImgList = fileList;
            console.log(this.addLabelImgList);
            //  let url=this.prewWorkerImg(res.data.data.id);
            //  this.skillImgList.push(res.data.data.fileUrl);
          }
        });
      }
    },
    handleOnChange2(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);

        let filesize = Number(file.size / 1024 / 1024);
        if (filesize > 3) {
          this.$message.error("上传图片不能超过3M,请重新上传");
          const currIdx = this.editLabelImgList.indexOf(file);
          this.editLabelImgList.splice(currIdx, 0);
          return;
        }

        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.editLabelImgList = fileList;
            console.log(this.editLabelImgList);
            //  let url=this.prewWorkerImg(res.data.data.id);
            //  this.skillImgList.push(res.data.data.fileUrl);
          }
        });
      }
    },
    editLabel(row) {
      console.log(row);
      this.labelInfo = row;
      this.editLabelVisible = true;
      let list = row.files == "" ? [] : row.files.split(",");
      this.editLabelImgList = list.map(item => {
        return { url: item };
      });

      this.editLabelForm = {
        workerNo: row.workerNo,
        workerName: row.workerName,
        lableType: row.lableType,
        effectiveStart: this.formateDay(row.effectiveStart),
        effectiveEnd: this.formateDay(row.effectiveEnd),
        remark: row.remark
      };
    },

    uploadBtn() {
      this.inputVisible = true;
      if (this.file != "") {
        this.$refs.file.value = "";
      }
    },
    getFile: function(event) {
      this.file = event.target.files[0];
    },
    importConfirm() {
      if (this.file == "") {
        this.$message.warning("请选择文件！");
        return;
      }
      var formData = new window.FormData(); // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append("file", this.file);
      // formData.append("updateUser", globalData.userInfo.id);
      Service.$axiosImportNewSocialInsure(formData)
        .then(res => {
          // console.log(res);
          if (res.data.errno == 0) {
            this.$message.success("新农保明细导入成功！");
            this.inputVisible = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
.el-tag--small {
  height: 30px;
  padding: 0 8px;
  line-height: 30px;
  border: 1px solid #409eff;
}
.sugResponse {
  margin: 0 0 10px 0;
  color: #409eff;
  font-size: 12px;
}

</style>
